import styled from "styled-components";
import {Tabs} from "antd";

export const OuterTabsStyles = styled(Tabs)`
  & > .ant-tabs-nav {
    background-color: #fff;
    margin-bottom: 0;

    .ant-tabs-ink-bar {
      display: none;
    }

    .ant-tabs-tab {
      margin: 0;
      padding: 20px 24px;

      .ant-tabs-tab-btn {
        color: var(--c-title-text);
        font-size: 18px;
      }

      &.ant-tabs-tab-active {
        background-color: var(--c-hover);

        .ant-tabs-tab-btn {
          color: #fff;
        }
      }
    }
  }

  & > .ant-tabs-content-holder {
    background-color: #fff;
  }
`